// extracted by mini-css-extract-plugin
export default {"heading":"Vq-z","createAccount":"Wq-z","disabled":"Xq-z","copy":"Yq-z","terms":"Zq-z"};